import type { Messages } from '@/types'

const messages: Messages = {
    common: {
        actions: {
            add: 'إضافة',
            edit: 'تعديل',
            delete: 'حذف',
            cancel: 'إلغاء',
            back: 'رجوع',
            save: 'حفظ',
            update: 'تحديث',
            reset: 'إعادة تعيين',
            refresh: 'تحديث',
            backToList: '@:common.back إلى القائمة',
            resetDefaults: '@:common.reset إلى الافتراضي',
            confirm: 'تأكيد',
            proceed: 'متابعة',
            close: 'إغلاق',
            apply: 'تطبيق',
            search: 'بحث',
            filter: 'تصفية',
            clear: 'مسح',
            select: 'اختيار',
            upload: 'رفع',
            download: 'تحميل',
            view: 'عرض',
            sort: 'ترتيب',
            seeMore: 'المزيد'
        },
        status: {
            success: 'نجح',
            error: 'خطأ',
            loading: 'جاري التحميل...'
        },
        messages: {
            deleteConfirm: 'هل أنت متأكد من حذف هذا المستخدم؟',
            generalError: 'حدث خطأ ما! يرجى المحاولة مرة أخرى',
            addSuccess: 'تمت إضافة السجل بنجاح!',
            updateSuccess: 'تم تحديث السجل بنجاح!',
        },
        placeholder: {
            avatar: '?'
        },
        labels: {
            loading: 'جاري التحميل',
            noResults: 'لم يتم العثور على نتائج',
            noData: 'لا توجد بيانات متاحة',
            selected: 'محدد',
            required: 'مطلوب',
            optional: 'اختياري',
            search: 'بحث...',
            filter: 'تصفية...',
            from: 'من',
            to: 'إلى',
            date: 'التاريخ',
            status: 'الحالة',
            item: 'العنصر {index}',
            addItem: 'إضافة عنصر',
            removeItem: 'إزالة عنصر',
            skipToMain: 'التخطي إلى المحتوى الرئيسي',
            openNavigation: 'فتح التنقل',
            closeNavigation: 'إغلاق التنقل',
            mainNavigation: 'التنقل الرئيسي',
            moveUp: 'نقل لأعلى',
            moveDown: 'نقل لأسفل',
            and: 'و'
        },
        errors: {
            upload: 'فشل رفع الملف',
            download: 'فشل تحميل الملف',
            generic: 'حدث خطأ',
            notFound: 'غير موجود',
            unauthorized: 'وصول غير مصرح به',
            validation: 'يرجى التحقق من المدخلات'
        },
        validation: {
            required: 'هذا الحقل مطلوب',
            email: 'عنوان بريد إلكتروني غير صالح',
            minLength: 'الحد الأدنى للطول هو {length}',
            maxLength: 'الحد الأقصى للطول هو {length}',
            min: 'الحد الأدنى للقيمة هو {min}',
            max: 'الحد الأقصى للقيمة هو {max}',
            matches: 'تنسيق غير صالح',
            unique: 'يجب أن تكون القيمة فريدة',
            confirm: 'كلمات المرور غير متطابقة'
        }
    },
    pages: {
        users: {
            title: 'المستخدمون',
            description: 'إدارة مستخدمي النظام',
            actions: {
                invite: 'دعوة مستخدم',
                resetPassword: 'إعادة تعيين كلمة المرور'
            }
        },
        settings: {
            title: 'الإعدادات',
            actions: {
                resetDefaults: 'إعادة تعيين إلى الافتراضي'
            }
        },
        reports: {
            title: 'التقارير',
            description: 'إنشاء وتحميل التقارير',
            actions: {
                generateReport: 'إنشاء تقرير',
                downloadCsv: 'تحميل CSV',
                startDate: 'تاريخ البدء',
                endDate: 'تاريخ الانتهاء',
                apps: 'التطبيقات',
            },
            error: {
                generation: 'فشل إنشاء التقرير',
                download: 'فشل تحميل التقرير'
            }
        }
    },
    navigation: {
        home: 'الرئيسية',
        library: 'المكتبة',
        search: 'بحث',
        login: 'تسجيل الدخول',
        signInToGetPremium: 'احصل على Premium',
        subscribe: 'اشتراك',
        support: 'الدعم',
        settings: 'الإعدادات',
        logout: 'تسجيل الخروج'
    },
    settings: {
        title: 'الإعدادات',
        description: 'إدارة إعدادات حسابك وتفضيلاتك ومعلومات ملفك الشخصي.',
        sections: 'أقسام الإعدادات',
        menu: {
            profile: 'الملف الشخصي',
            account: 'الحساب',
            general: 'عام',
            purchases: 'المشتريات',
            activity: 'النشاط'
        },
        profile: {
            title: 'الملف الشخصي',
            changeImage: 'تغيير الصورة',
            updateProfile: 'تحديث الملف الشخصي',
            changePassword: 'تغيير كلمة المرور',
            updatePassword: 'تحديث كلمة المرور',
            fields: {
                fullName: 'الاسم الكامل',
                emailAddress: 'عنوان البريد الإلكتروني',
                dateOfBirth: 'تاريخ الميلاد',
                currentPassword: 'كلمة المرور الحالية',
                newPassword: 'كلمة المرور الجديدة',
                confirmNewPassword: 'تأكيد كلمة المرور الجديدة'
            },
            toasts: {
                imageUpdated: 'تم تحديث الصورة',
                imageUpdatedMessage: 'تم تحديث صورة ملفك الشخصي بنجاح',
                uploadFailed: 'فشل الرفع',
                profileUpdated: 'تم تحديث الملف الشخصي',
                profileUpdatedMessage: 'تم تحديث ملفك الشخصي بنجاح',
                passwordUpdated: 'تم تحديث كلمة المرور',
                passwordUpdatedMessage: 'تم تحديث كلمة المرور بنجاح',
                passwordError: 'خطأ في كلمة المرور',
                passwordMismatch: 'كلمات المرور غير متطابقة',
                passwordTooWeak: 'كلمة المرور ضعيفة جداً'
            }
        },
        account: {
            title: 'الحساب',
            accountInformation: 'معلومات الحساب',
            emailAddress: 'عنوان البريد الإلكتروني',
            memberSince: 'عضو منذ',
            redeemPromoCode: 'استخدام رمز الترويج',
            redeemPromoCodeDescription: 'لديك رمز ترويج أو هدية؟ أدخله هنا لتطبيقه على حسابك أو اشتراكك القادم.',
            subscription: {
                title: 'الاشتراك',
                currentPlan: 'الخطة الحالية',
                premiumSubscription: 'اشتراك مميز',
                nextRenewal: 'التجديد القادم:',
                accessUntil: 'الوصول حتى:',
                manageInAppStore: 'تم شراء اشتراكك عبر App Store. لإلغائه أو تغييره، افتح الاشتراكات في إعدادات Apple ID على الجهاز الذي استخدمته للاشتراك.',
                manageInPlayStore: 'تم شراء اشتراكك عبر Google Play. لإلغائه أو تغييره، افتح الاشتراكات في Google Play Store على الجهاز الذي استخدمته للاشتراك.',
                notSubscribed: 'أنت غير مشترك حالياً في أي خطة.',
                subscribeNow: 'اشترك الآن',
                findOutMore: 'اعرف المزيد',
                cancelSubscription: 'إلغاء الاشتراك',
                cancelSubscriptionTitle: 'إلغاء الاشتراك',
                cancelSubscriptionMessage: 'هل أنت متأكد من إلغاء اشتراكك؟ ستفقد الوصول إلى المحتوى المميز في نهاية فترة الفوترة الحالية.',
                keepSubscription: 'الاحتفاظ بالاشتراك',
                toasts: {
                    subscriptionActivated: 'تم تفعيل الاشتراك',
                    subscriptionActivatedMessage: 'مرحباً بك في Premium!',
                    subscriptionFailed: 'فشل الاشتراك',
                    paymentMethodUpdated: 'تم تحديث طريقة الدفع',
                    paymentMethodUpdatedMessage: 'تم تحديث معلومات الدفع بنجاح',
                    subscriptionCancelled: 'تم إلغاء الاشتراك',
                    subscriptionCancelledMessage: 'سينتهي اشتراكك في فترة الفوترة الحالية',
                    cancellationFailed: 'فشل الإلغاء'
                }
            },
            closeAccount: {
                title: 'إغلاق الحساب',
                requestDescription: 'طلب إغلاق حسابك بشكل دائم. لا يمكن التراجع عن هذا الإجراء.',
                requestButton: 'طلب إغلاق الحساب',
                confirmationTitle: 'هل أنت متأكد من رغبتك في تعطيل حسابك؟ سيؤدي هذا إلى:',
                confirmationItems: {
                    cancelSubscription: 'إلغاء اشتراكك النشط (إن وجد)',
                    removeCommunications: 'إزالتك من جميع الاتصالات',
                    scheduleDeletion: 'جدولة حذف بياناتك بشكل دائم بعد 30 يوماً'
                },
                confirmationWarning: 'يمكنك إلغاء طلب التعطيل في أي وقت خلال 30 يوماً. بعد هذه الفترة، سيتم حذف حسابك وجميع البيانات المرتبطة به بشكل دائم.',
                confirmationCheckbox: 'أفهم أن حسابي سيتم حذفه بشكل دائم بعد 30 يوماً',
                deactivateAccount: 'تعطيل الحساب',
                cancel: 'إلغاء',
                scheduledTitle: 'تم جدولة تعطيل الحساب',
                scheduledMessage: 'تم جدولة حسابك للحذف الدائم في',
                scheduledWarning: 'خلال هذه الفترة، لن تتمكن من تسجيل الدخول إلى حسابك. إذا غيرت رأيك، يمكنك إلغاء عملية التعطيل.',
                cancelDeactivation: 'إلغاء تعطيل الحساب',
                toasts: {
                    deactivationRequested: 'تم طلب تعطيل الحساب',
                    deactivationRequestedMessage: 'سيتم حذف حسابك بشكل دائم خلال 30 يوماً',
                    deactivationFailed: 'فشل التعطيل',
                    deactivationCancelled: 'تم إلغاء التعطيل',
                    deactivationCancelledMessage: 'لم يعد حسابك مجدولاً للحذف'
                }
            }
        },
        purchases: {
            title: 'سجل المشتريات',
            noPurchases: 'لم يتم العثور على مشتريات',
            invoice: 'فاتورة'
        },
        activity: {
            title: 'الجدول الزمني للنشاط',
            dateRange: 'نطاق التاريخ',
            activityType: 'نوع النشاط',
            noActivities: 'لم يتم العثور على أنشطة',
            resume: 'متابعة',
            loadMore: 'تحميل المزيد',
            filters: {
                last7Days: 'آخر 7 أيام',
                last30Days: 'آخر 30 يوماً',
                lastYear: 'العام الماضي',
                allTime: 'كل الوقت',
                allActivities: 'جميع الأنشطة',
                listening: 'الاستماع',
                purchases: 'المشتريات',
                likes: 'الإعجابات',
                bookmarks: 'الإشارات المرجعية'
            },
            types: {
                listenedTo: 'تم الاستماع إلى {title}',
                purchased: 'تم شراء {title}',
                liked: 'أعجب {title}',
                bookmarked: 'تم وضع إشارة مرجعية على {title}'
            }
        },
        appSettings: {
            title: 'إعدادات التطبيق',
            darkMode: 'الوضع الداكن',
            language: 'اللغة',
            languageOptions: {
                english: 'الإنجليزية',
                spanish: 'الإسبانية',
                french: 'الفرنسية',
                german: 'الألمانية',
                italian: 'الإيطالية',
                portuguese: 'البرتغالية',
                dutch: 'الهولندية',
                slovak: 'السلوفاكية',
                russian: 'الروسية',
                arabic: 'العربية'
            }
        },
        notifications: {
            title: 'الإشعارات',
            emailNotifications: 'إشعارات البريد الإلكتروني',
            emailNotificationsHint: 'تلقي التحديثات عبر البريد الإلكتروني',
            pushNotifications: 'الإشعارات الفورية',
            pushNotificationsHint: 'تلقي الإشعارات الفورية',
            updatePreferences: 'تحديث التفضيلات'
        },
        toasts: {
            themeUpdated: 'تم تحديث المظهر',
            themeUpdatedMessage: 'تم حفظ تفضيل المظهر',
            languageUpdated: 'تم تحديث اللغة',
            languageUpdatedMessage: 'تم حفظ تفضيل اللغة',
            preferencesUpdated: 'تم تحديث التفضيلات',
            preferencesUpdatedMessage: 'تم حفظ تفضيلات الإشعارات',
            updateFailed: 'فشل التحديث',
            updateFailedMessage: 'فشل تحديث الإعداد',
            updateFailedNotificationMessage: 'فشل تحديث تفضيلات الإشعارات'
        }
    },
    auth: {
        login: {
            title: 'تسجيل الدخول',
            description: 'قم بتسجيل الدخول إلى حساب Heard للوصول إلى مكتبتك والمحتوى المميز',
            signIn: 'تسجيل الدخول',
            signInToAccount: 'قم بتسجيل الدخول إلى حسابك',
            noAccount: 'ليس لديك حساب؟',
            signUp: 'التسجيل',
            continueAsGuest: 'المتابعة كضيف',
            or: 'أو',
            agreeToTerms: 'بتسجيل الدخول، أنت توافق على',
            termsOfService: 'شروط الخدمة',
            privacyPolicy: 'سياسة الخصوصية',
            forgotPassword: 'نسيت كلمة المرور؟'
        },
        register: {
            title: 'التسجيل',
            description: 'سجل للحصول على حساب Heard للوصول إلى المحتوى الصوتي المميز وإنشاء مكتبة شخصية والمزيد',
            createAccount: 'إنشاء حساب',
            createYourAccount: 'أنشئ حسابك',
            orSignIn: 'أو',
            signIn: 'تسجيل الدخول',
            backToHome: 'العودة إلى الرئيسية',
            agreeToTerms: 'بإنشاء حساب، أنت توافق على',
            termsOfService: 'شروط الخدمة',
            privacyPolicy: 'سياسة الخصوصية'
        },
        forms: {
            email: 'عنوان البريد الإلكتروني',
            password: 'كلمة المرور',
            confirmPassword: 'تأكيد كلمة المرور',
            fullName: 'الاسم الكامل',
            rememberMe: 'تذكرني',
            signIn: 'تسجيل الدخول',
            createAccount: 'إنشاء حساب'
        },
        toasts: {
            loginSuccess: 'تم تسجيل الدخول بنجاح',
            loginFailed: 'فشل تسجيل الدخول',
            registerSuccess: 'تم إنشاء الحساب بنجاح',
            registerFailed: 'فشل التسجيل'
        }
    },
    library: {
        title: 'مكتبتي',
        description: 'الوصول إلى العناوين التي تم تشغيلها مؤخراً والمفضلة والمشتراة والمشار إليها والمنتهية في مكتبتك الشخصية.',
        sections: 'أقسام المكتبة',
        noItems: 'لا توجد عناصر في هذا القسم',
        sync: 'مزامنة المكتبة',
        tabs: {
            recent: 'متابعة',
            liked: 'المفضلة',
            purchased: 'مشترى',
            bookmarked: 'مشار إليه',
            finished: 'استمع مرة أخرى',
            finishedWatch: 'شاهد مرة أخرى',
            finishedRead: 'اقرأ مرة أخرى'
        }
    },
    home: {
        title: 'الرئيسية',
        error: {
            loadFailed: 'فشل تحميل المحتوى'
        }
    },
    player: {
        chapters: 'الفصول',
        options: 'الخيارات',
        playbackSpeed: 'سرعة التشغيل',
        share: 'مشاركة',
        linkCopied: 'تم نسخ الرابط',
        linkCopiedMessage: 'تم نسخ رابط المشاركة إلى الحافظة!',
        shareError: 'خطأ في المشاركة',
        shareErrorMessage: 'تعذر نسخ رابط المشاركة. يرجى المحاولة مرة أخرى.',
        bookmarkAdded: 'نجح',
        bookmarkAddedMessage: 'تمت إضافة الإشارة المرجعية!',
        jumpedToBookmark: 'نجح',
        jumpedToBookmarkMessage: 'تم الانتقال إلى الإشارة المرجعية!',
        likeError: 'خطأ في الإعجاب',
        likeErrorMessage: 'تعذر تحديث حالة الإعجاب. يرجى المحاولة مرة أخرى.',
        bookmarkError: 'خطأ في الإشارة المرجعية',
        bookmarkErrorMessage: 'تعذر تحديث الإشارة المرجعية. يرجى المحاولة مرة أخرى.',
        favorites: {
            add: 'إضافة إلى المفضلة',
            remove: 'إزالة من المفضلة'
        },
        unknownChapter: 'فصل غير معروف',
        unknownTitle: 'عنوان غير معروف',
        unknownAuthor: 'مؤلف غير معروف'
    },
    details: {
        starring: 'بطولة:',
        author: 'المؤلف',
        narrator: 'الراوي',
        pause: 'إيقاف مؤقت',
        purchased: 'مشترى',
        continueReading: 'متابعة القراءة',
        continuePlaying: 'متابعة التشغيل',
        play: 'تشغيل',
        loading: 'جاري التحميل...',
        noChapters: 'لا توجد فصول متاحة',
        chapterFreeLabel: 'مجاني',
        listen: 'استمع',
        purchaseSuccess: 'نجحت عملية الشراء',
        purchaseSuccessMessage: 'تمت إضافة {title} إلى مكتبتك',
        subscriptionSuccess: 'نجح الاشتراك',
        subscriptionSuccessMessage: 'مرحباً بك في Heard Premium!',
        subscriptionFailed: 'فشل الاشتراك',
        subscriptionErrorMessage: 'حدث خطأ أثناء معالجة اشتراكك.',
        info: 'معلومات',
        more: 'المزيد',
        episodes: 'حلقات',
        about: 'حول',
        series: 'سلسلة',
        producedBy: 'من إنتاج',
        recommendations: 'قد يعجبك أيضًا',
        moreFromCategory: 'المزيد من {name}',
        moreFromAuthor: 'المزيد من {name}',
        moreFromCast: 'المزيد من {name}',
        moreFromSeries: 'المزيد في {name}',
        noRelated: 'لا توجد عناوين ذات صلة متاحة الآن.',
        ageVerification: {
            title: 'للبالغين فقط',
            message: 'هذا المحتوى مخصص للبالغين فقط. يرجى تأكيد رغبتك في المتابعة.',
            minAgeHint: 'يجب أن يكون عمرك {age} عامًا على الأقل لمشاهدة هذا العنوان.',
            confirm: 'أنا بالغ، متابعة',
            cancel: 'إلغاء',
            missingDobTitle: 'تاريخ الميلاد مطلوب',
            missingDobMessage: 'أضف تاريخ ميلادك في ملفك الشخصي لمشاهدة هذا المحتوى.',
            underageTitle: 'مقيد بالعمر',
            underageMessage: 'يجب أن يكون عمرك {age} عامًا على الأقل لمشاهدة هذا المحتوى.',
        },
    },
    shareModal: {
        title: 'مشاركة',
        copyLink: 'نسخ الرابط',
        copyLinkWithMessage: 'نسخ الرابط مع الرسالة',
        copyLinkWithMessageHint: 'يتضمن العنوان والوصف',
        shareVia: 'مشاركة عبر...',
        shareViaHint: 'التطبيقات والرسائل والبريد',
        linkCopied: 'تم نسخ الرابط',
        linkCopiedMessage: 'تم نسخ رابط المشاركة!',
        shared: 'تمت المشاركة',
        sharedMessage: 'تم مشاركة المحتوى بنجاح'
    },
    contextMenu: {
        playFromBeginning: 'التشغيل من البداية',
        markAsFinished: 'وضع علامة كمنتهي',
        addToFavorites: 'إضافة إلى المفضلة',
        removeFromFavorites: 'إزالة من المفضلة',
        share: 'مشاركة',
        viewDetails: 'عرض التفاصيل',
        removeFromLibrary: 'إزالة من المكتبة',
        continuePlaying: 'متابعة التشغيل',
        continueReading: 'متابعة القراءة'
    },
    actions: {
        subscribe: 'اشتراك',
        signInToGetPremium: 'احصل على Premium',
        purchase: 'شراء',
        buy: 'شراء',
        buyFor: 'شراء مقابل {price}',
        purchasedGoToLibrary: 'مشترى - الانتقال إلى المكتبة',
        addToFavorites: 'إضافة إلى المفضلة',
        removeFromFavorites: 'إزالة من المفضلة',
        share: 'مشاركة'
    },
    browse: {
        sortBy: 'ترتيب حسب',
        sortOptions: {
            recent: 'الأحدث',
            ascending: 'أ-ي',
            descending: 'ي-أ'
        }
    },

    legal: {
        companyNumber: 'رقم الشركة',
        privacyPolicy: 'سياسة الخصوصية',
        termsOfService: 'شروط الخدمة',
        agreeToTermsSubscribe: 'بالاشتراك، أنت توافق على',
        operatedBy: 'يتم تشغيل {appName} بواسطة {companyName}، {address}',
        faqs: 'الأسئلة الشائعة'
    },
    support: {
        title: 'الدعم',
        description: 'هل تحتاج إلى مساعدة بخصوص حسابك أو اشتراكك أو تجربة الاستماع؟ تصفح الأسئلة الشائعة والمعلومات القانونية، أو اتصل بنا.',
        intro: 'هل تحتاج إلى مساعدة بخصوص حسابك أو اشتراكك أو تجربة الاستماع؟ تصفح الأسئلة الشائعة والمعلومات القانونية أدناه، أو اتصل بنا إذا كنت بحاجة إلى مزيد من المساعدة.',
        quickLinks: 'روابط سريعة',
        contactTitle: 'اتصل بالدعم',
        contactDescription: 'أرسل رسالة إلى فريق الدعم لدينا. تحقق من الأسئلة الشائعة أولاً للحصول على إجابات سريعة.',
        contactIntro: 'إذا كنت بحاجة إلى مساعدة، فنحن هنا من أجلك. تمت الإجابة على العديد من الأسئلة الشائعة بالفعل في مركز المساعدة.',
        contactIntroFaqBefore: 'يرجى الاطلاع على ',
        contactIntroFaqAfter: ' للحصول على إجابات للأسئلة الشائعة. إذا كنت لا تزال بحاجة إلى مساعدة، املأ النموذج وسنرد عليك في أقرب وقت ممكن.',
        contactSubmit: 'إرسال الرسالة',
        contactName: 'الاسم',
        contactEmail: 'البريد الإلكتروني',
        contactSubject: 'الموضوع',
        contactMessage: 'الرسالة',
        contactMessageHint: 'يرجى وصف مشكلتك بالتفصيل',
        backToSupport: 'العودة إلى الدعم',
        pageLoading: 'جارٍ التحميل…',
        pageNotAvailable: 'هذه الصفحة غير متاحة حالياً.',
        unsupportedSection: 'قسم محتوى غير مدعوم: {name}',
        useContactFormBefore: 'هل تحتاج إلى التواصل معنا؟ استخدم ',
        contactSuccessTitle: 'تم إرسال الرسالة',
        contactSuccessMessage: 'تم إرسال رسالتك. سنرد عليك في أقرب وقت ممكن.',
        contactErrorTitle: 'فشل الإرسال',
        contactErrorMessage: 'تعذر إرسال رسالتك. يرجى المحاولة مرة أخرى.'
    },
    promo: {
        haveCode: 'لديك رمز ترويج؟',
        placeholder: 'أدخل الرمز',
        apply: 'تطبيق',
        remove: 'إزالة',
        applied: '{name} – {discount}',
        invalidCode: 'رمز غير صالح أو منتهي الصلاحية.',
        expired: 'انتهت صلاحية هذا الرمز.',
        notValidForPurchase: 'هذا الرمز غير صالح لهذه الشراء.',
        free: 'مجاني',
        percentOff: 'خصم {value}٪',
        fixedOff: 'خصم {value}',
        useWhenSubscribe: 'استخدم هذا العرض عند الاشتراك أدناه.',
        useWhenPurchase: 'استخدم هذا الرمز عند شراء عنوان.',
        accessGranted: 'تم تطبيق الوصول على حسابك.'
    }
}

export default messages

